export class SidebarMenuToken {
  static IConfigRepository = Symbol("IConfigRepository");
  static SidebarMenuUseCase = Symbol("SidebarMenuUseCase");
}
